import { Location } from '@angular/common';
import { Component, Input, OnChanges, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Router } from '@angular/router';
import { userSelectors } from '@app/core/ngrx/selectors';
import { ApplicationService } from '@app/core/services/application/application.service';
import { ToolService } from '@app/core/services/tool/tool.service';
import { ModalService } from '@core/services/modal/modal.service';
import { State } from '@core/ngrx/reducers';
import { faExclamationCircle, faPhone, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { faCalendarStar, faPennant } from '@fortawesome/pro-solid-svg-icons';
import { NavController, PopoverController } from '@ionic/angular';
import { select, Store } from '@ngrx/store';
import { isNil } from '@shared/utils/index';
import { ApplicationAdvisorListComponent } from '../application-advisor-list/application-advisor-list.component';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-customer-actions',
    templateUrl: './application-quick-actions.component.html',
    styleUrls: ['./application-quick-actions.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, FontAwesomeModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ApplicationQuickActionsComponent implements OnChanges {
    icons: any = {
        question: faQuestionCircle,
        phone: faPhone,
        exclamation: faExclamationCircle,
        calendar: faCalendarStar,
        pennant: faPennant,
    };

    @Input() program: any;
    @Input() application: any;
    @Input() content?: any;
    sidebar: any = {};
    applicationState: string;

    programDetails: boolean;
    applicationDetails: boolean;

    favorite: any[] = [];
    textcontent: any;

    censorContent$ = this.store.pipe(select(userSelectors.blockContent)); // visitor block content if 'unmanaged'

    constructor(
        private applicationService: ApplicationService,
        private popoverCtrl: PopoverController,
        private navCtrl: NavController,
        private location: Location,
        private toolService: ToolService,
        private modalService: ModalService,
        private router: Router,
        private store: Store<State>
    ) {}

    ngOnChanges(): void {
        this.programDetails = this.program ? true : false;
        this.applicationDetails = this.application ? true : false;
        this.toolService.content.subscribe((textcontent: any) => (this.textcontent = textcontent));
        // for the program details page
        if (isNil(this.application)) {
            this.sidebar.advisor = true;
            this.sidebar.coach = false;
        } else if (!this.application.madepayment || this.application.madedeposit || this.application.madefullpayment) {
            this.sidebar.advisor = true;

            this.sidebar.coach = false;

            if (this.application.states === 'Pending' && !this.application.program.preapprovalrequired) {
                this.applicationState = 'Pay and Reserve';
            } else if (this.application.states === 'Pending' && this.application.program.preapprovalrequired) {
                this.applicationState = 'Pay and Upload Documents';
            } else if (this.application.states === 'Pending-Booked') {
                this.applicationState = 'Application in Review';
            } else if (this.application.states === 'Pre-Approved') {
                this.applicationState = 'Pre Approved';
            } else if (this.application.states === 'Accepted') {
                this.applicationState = 'Pay and Reserve';
            } else if (
                this.application.states === 'Reserved' &&
                this.application.program.requiredpostdocumentlist.requireContract &&
                this.application.signedcontract === null
            ) {
                this.applicationState = 'Sign Agreement';
            } else {
                this.applicationState = 'Complete Application';
            }
        } else {
            this.sidebar.advisor = false;
            this.sidebar.coach = true;
        }
    }

    contactCoachFunction(ev: any) {
        this.contactCoach(ev);
    }

    contactAdvisorFunction(ev: any) {
        this.contactAdvisor(ev);
    }

    async contactAdvisor(ev: any) {
        const popover = await this.popoverCtrl.create({
            component: ApplicationAdvisorListComponent,
            event: ev,
            mode: 'ios',
            cssClass: 'contact-popover',
            componentProps: {
                application: this.application,
                advisor: this.sidebar.advisor,
            },
        });
        return popover.present();
    }

    async contactCoach(ev: any) {
        const popover = await this.popoverCtrl.create({
            component: ApplicationAdvisorListComponent,
            event: ev,
            mode: 'ios',
            cssClass: 'contact-popover',
            componentProps: {
                application: this.application,
                coach: this.sidebar.coach,
            },
        });
        return popover.present();
    }

    LinktoFAQ = () => {
        window.open(this.textcontent.basic.url.faq, '_blank');
    };

    async cancelApplication(applicationId: string) {
        const result = await this.modalService.confirmation({
            title: 'Cancel Application',
            message: `
      You are about to cancel your application for: \n\n
      ${this.application.specialty}, \n\n
      ${this.application.name} \n\n
      `,
            buttonText: `Yes, cancel this application.`,
            buttonColor: 'danger',
        });

        if (result.data.confirmed) {
            this.applicationService.cancelApplication(applicationId).subscribe((res: any) => {
                const url = this.router.createUrlTree(['/dashboard']).toString();
                this.location.replaceState(url);
                location.reload();
            });
        }
    } // end cancel application
}
